import React, { createContext, useState } from 'react';
import BookingModal, { Props as BookingModalProps } from 'components/BookingModal/BookingModal';

export const BookItNowModalOpenContext = createContext(null);
BookItNowModalOpenContext.displayName = 'BookItNowModalOpenContext';
export const BookItNowModalPropsContext = createContext(null); // only the BookItNowButton should access these props

export const BookItNowModalOpenProvider = ({ children }: { children: React.ReactNode }) => {

  const [isModalOpen, setShowModal] = useState(false);
  const [modalProps, setModalProps] = useState<BookingModalProps>({} as BookingModalProps);

  return (
    <>
      {isModalOpen && <BookingModal setShowModal={setShowModal} {...modalProps} />}
      <BookItNowModalPropsContext.Provider value={setModalProps}>
        <BookItNowModalOpenContext.Provider value={[isModalOpen, setShowModal]}>
          {children}
        </BookItNowModalOpenContext.Provider>
      </BookItNowModalPropsContext.Provider>
    </>
  )
}
